import { render, staticRenderFns } from "./ServiceDescriptionTable.vue?vue&type=template&id=72991af4"
import script from "./ServiceDescriptionTable.vue?vue&type=script&lang=js"
export * from "./ServiceDescriptionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports